export default {
  api: {
    baseUrl: 'https://api.onlinetraining.com.tr',
    // baseUrl: 'http://localhost:8080',
  },
}
